export default __webpack_public_path__ + "static/hero-l8-2-0ad8c888176c53277b15c7d9839512c2.png";